import React from "react";
import FormSelect from "../FormSelect";
import ProfileIcon from "../../ProfileIcon";
import { components } from "react-select";
import { useFetchUsersQuery } from "../../../services/identity";

export const GenericAdviserSelectOption = (props) => {
    const { data: { data }, label } = props;
    if (!data) {
        return (
            <components.Option {...props}><span>{label}</span></components.Option>
        )
    }

    const { isOnline } = data;
    return (
        <components.Option {...props}>
            <div className="d-flex align-items-center">
                <div className="d-flex align-items-center justify-center">
                    <ProfileIcon user={data} isOnline={isOnline} showOnlineStatusIndicator={true} width={24} height={24} />
                </div>
                <p className="mx-2 my-0 lh-1">
                    <span>{label}</span>
                </p>
            </div>
        </components.Option>
    );
};

export const GenericAdviserSelectSingleValue = (props) => {
    const { data: { data }, label } = props;
    if (!data) {
        return (
            <components.SingleValue {...props}><span>{label}</span></components.SingleValue>
        )
    }

    const { isOnline, displayName } = data;
    return (
        <components.SingleValue {...props}>
            <div className="d-flex align-items-center">
                <div className="d-flex align-items-center justify-center">
                    <ProfileIcon user={data} isOnline={isOnline} showOnlineStatusIndicator={true} width={24} height={24} />
                </div>
                <p className="mx-2 my-0 lh-1">
                    <span>{label ?? displayName}</span>
                </p>
            </div>
        </components.SingleValue>
    );
};

const GenericAdviserSelect = ({ options, divisionId = null, includeInactive = false, displayOther = false, components, ...rest }) => {
    const { data, error, isError, isLoading, isFetching } = useFetchUsersQuery({ 
        divisions: divisionId ?? null, 
        includeInactive
    });

    const _map = (el) => {
        return {
            label: el.displayName,
            value: el.id,
            isDisabled: el.isActive === false || el.isVisible === false,
            data: el
        };
    };
    
    const dataOptions = React.useMemo(() => {
        if (!data || !data.results) {
            return [];
        }

        return [
            {
                label: 'Advisers',
                options: data.results.filter(el => el.typeId === 0 && el.isActive === true && el.isVisible === true).map(_map)
            },
            {
                label: 'Other Users',
                options: data.results.filter(el => displayOther === true && el.typeId !== 0 && el.isActive === true && el.isVisible === true).map(_map)
            },
            {
                label: 'Inactive Users',
                options: data.results.filter(el => includeInactive === true && (el.isActive === false || el.isVisible === false)).map(_map)
            }
        ];
    }, [ data ]); 
    
    return <FormSelect
        options={dataOptions}
        isLoadingOptions={isLoading || isFetching}
        components={{
            ...components,
            Option: GenericAdviserSelectOption,
            SingleValue: GenericAdviserSelectSingleValue
        }}
        {...rest}
    />
};

export default GenericAdviserSelect;